var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLangIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5685_18551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22C14.6667 19.4482 16 16.4657 16 12C16 7.53429 14.6667 4.55183 12 2C9.33333 4.55183 8 7.53429 8 12C8 16.4657 9.33333 19.4482 12 22Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9H22M2 15H22",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5685_18551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangIcon);
export default __webpack_public_path__ + "static/media/LangIcon.b6934bb5ae4bbe9a59934f2123915f0e.svg";
export { ForwardRef as ReactComponent };